// src/hooks/useVisitorId.js
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { processVisitor } from "@/api/home";

const useVisitorId = () => {
  const [visitorId, setVisitorId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrCreateVisitorId = async () => {
    try {
      const { visitorId } = await processVisitor();
      Cookies.set("visitorId", visitorId, { expires: 365 });
      setVisitorId(visitorId);
    } catch (err) {
      setError(err);
      console.error("Error managing visitor ID:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrCreateVisitorId();
  }, []);

  return { visitorId, loading, error };
};

export default useVisitorId;
